import React from 'react'

export default function Project() {
  return (
    <div>
        <div className="container" id="project" style={{
            maxWidth:'100%', backgroundColor:'black', maxHeight:'100%'
        }}>
      <div className="container-fluid project1"style={{
        maxWidth:'1440px',
        }}>
<div className="container-fluid project2">
  <div className="row text-center pt-5">
    <h1 className='text-white projecth2 sora' style={{
      fontWeight: '400',
      paddingTop: '20px',
      paddingBottom: '20px'
    }}>MY <span style={{fontWeight:'800'}}>Projects</span></h1>
  </div>
  <div className="row project3 ">
    <div className="col-lg-6 col-md-6 col-sm-12">
      <div className="hide my-3 text-white" style={{fontSize:'28px', fontWeight:'800'}}>01</div>
      <img src="/images/image.png" alt="" className='project4' style={{
        maxWidth: '100%',
        height: 'auto'
      }} />
    </div>
    <div className="col-lg-6 col-md-6 col-sm-12 d-flex flex-column justify-content-start project5 mt-md-5 mt-lg-5" style={{
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'start'
    }}>
      <div style={{
        margin: 'auto 0'
      }}>
        <h1 className='text-white projecth1 pt-lg-5 mt-lg-5 pt-md-5 mt-md-5 mt-4 sora'>McDONALD's</h1>
        <p className='projectp1 sora' style={{
          color: '#71717A'
        }}>One of the posts i desgined for Iqbal Day.</p>
      </div>
    </div>
  </div>
  <div className="row project3 mt-5 d-flex flex-column flex-md-row-reverse">
  <div className="col-lg-6 col-md-6 col-sm-12">
  <div className="hide my-3 text-white" style={{fontSize:'28px', fontWeight:'800'}}>02</div>
    <img src="/images/image (1).png" alt="" className="project4" style={{
      maxWidth: '100%',
      height: 'auto'
    }} />
  </div>
  <div className="col-lg-6 col-md-6 col-sm-12 d-flex flex-column justify-content-start project5 mt-md-5 mt-lg-5" style={{
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'start'
  }}>
    <div style={{
      margin: 'auto 0'
    }}>
      <h1 className='text-white projecth1 pt-lg-5 mt-lg-5 pt-md-5 mt-md-5 mt-4 sora'>T-Mobile</h1>
      <p className="projectp1 sora" style={{
        color: '#71717A'
      }}>Designed Jet Ski warps for one of their beach events.</p>
    </div>
  </div>
</div>

  <div className="row project3 mt-5">
    <div className="col-lg-6 col-md-6 col-sm-12">
    <div className="hide my-3 text-white" style={{fontSize:'28px', fontWeight:'800'}}>03</div>
      <img src="/images/project3.png" alt="" className='project4' style={{
        maxWidth: '100%',
        height: 'auto'
      }} />
    </div>
    <div className="col-lg-6 col-md-6 col-sm-12 d-flex flex-column justify-content-start project5 mt-md-5 mt-lg-5" style={{
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'start'
    }}>
      <div style={{
        margin: 'auto 0'
      }}>
        <h1 className='text-white projecth1 pt-lg-5 mt-lg-5 pt-md-5 mt-md-5 mt-4 sora'>Karishma Kewalramani</h1>
        <p className='projectp1 sora' style={{
          color: '#71717A'
        }}>Made this logo for her, a Pakistani fashion designer based in Pakistan and Dubai.</p>
      </div>
    </div>
  </div>
</div>
      </div>
          </div>
    </div>
  )
}
